<topbar> <h1 topbar-title>Check Submissions</h1> </topbar>

<page pTitle="Check Submissions">
    <card>
        <card-section>
            <stack pDistribution="trailing">
                <form-field>
                    <custom-date-time-picker
                        name="site_check_date"
                        id="site_check_dat"
                        [(ngModel)]="dateSelected"
                        (dateChanged)="onDateChanged($event)"
                        hideTimePicker="true"
                    ></custom-date-time-picker>
                </form-field>
                <form-field>
                    <mat-select
                        class="btn__select"
                        name="status"
                        [(ngModel)]="locationSelected"
                        (selectionChange)="onSelectionChanged($event.value)"
                    >
                        <mat-option
                            [value]="location"
                            *ngFor="let location of locations"
                        >
                            {{ location }}
                        </mat-option>
                    </mat-select>
                </form-field>
                <form-field>
                    <mat-select
                        class="btn__select"
                        name="status"
                        [(ngModel)]="checkTypeSelected"
                        (selectionChange)="onSelectionChanged($event.value)"
                    >
                        <mat-option
                            [value]="checkType"
                            *ngFor="let checkType of checkTypes"
                        >
                            {{ checkType }}
                        </mat-option>
                    </mat-select>
                </form-field>
            </stack>
        </card-section>
        <card-section>
            <div *ngIf="checkTypeSelected == 'Vehicle Presence Check'">
                <div *ngIf="sessionCheck != null && successfulPresenceChecks.length > 0"> Check performed by <b>{{sessionCheck.checkin_user}}</b>. Started at <b>{{formatTime(firstSuccessfulPresenceCheck.created_date)}}</b>. Finished at <b>{{formatTime(sessionCheck.created_date)}}</b></div>
                <details *ngIf="presenceReconciliations.length > 0">
                    <summary class="right-arrow">
                        <b>{{presenceReconciliations.length}}</b> <span class="accordion-header-text">vehicles reconciled</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="presenceReconciliations">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.Reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Outcome: {{ displayReconciliationOutcome(vehicle.vehicle_presence_check_reconciliation_outcome, vehicle.location) }}
                                    </p>
                                    <p>
                                        Reconciled on: {{formatDateTime(vehicle.vehicle_presence_check_reconciliation_date)}}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.vehicle_presence_check_reconciliation_by }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
                <details *ngIf="sessionCheck !== null && successfulPresenceChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{successfulPresenceChecks.length}}</b> <span class="accordion-header-text">vehicles checked in (marked as present)</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="successfulPresenceChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Status: {{ vehicle.check_status }}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.check_in_user }} |
                                        Location: {{ vehicle.check_in_location }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="sessionCheck !== null && vehiclesMissedChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehiclesMissedChecks.length}}</b> <span class="accordion-header-text">vehicles unaccounted for</span>
                    </summary>


                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehiclesMissedChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
                
                <details *ngIf="vehiclesReconciliated.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehiclesReconciliated.length}}</b> <span class="accordion-header-text">vehicles accounted for</span>
                    </summary>


                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehiclesReconciliated">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
            </div>

            <div *ngIf="checkTypeSelected == 'Vehicle Key Check'">
                <div *ngIf="successfulKeyChecks.length > 0"> Check performed by <b>{{successfulKeyChecks[0].check_in_user}}</b>. Started at <b>{{formatTime(sortedSuccessfulKeyChecks[0].created_date)}}</b>. Finished at <b>{{formatTime(sortedSuccessfulKeyChecks[sortedSuccessfulKeyChecks.length - 1].created_date)}}</b></div>
                <details *ngIf="keyReconciliations.length > 0">
                    <summary class="right-arrow">
                        <b>{{keyReconciliations.length}}</b> <span class="accordion-header-text">vehicles reconciled</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="keyReconciliations">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.Reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Outcome: {{ displayReconciliationOutcome(vehicle.vehicle_key_check_reconciliation_outcome, undefined) }}
                                    </p>
                                    <p>
                                        Reconciled on: {{formatDateTime(vehicle.vehicle_key_check_reconciliation_date)}}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.vehicle_key_check_reconciliation_by }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
                <details *ngIf="successfulKeyChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{successfulKeyChecks.length}}</b> <span class="accordion-header-text">vehicle keys present</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="successfulKeyChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Status: {{ vehicle.check_status }}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.check_in_user }} |
                                        Location: {{ vehicle.check_in_location }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleCheckDtos.length > 0 && vehiclesMissedKeyChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehiclesMissedKeyChecks.length}}</b> <span class="accordion-header-text">vehicle keys unaccounted for</span>
                    </summary>


                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehiclesMissedKeyChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleArrivalsFromKeyChecksSource.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehicleArrivalsFromKeyChecksSource.length}}</b> <span class="accordion-header-text">vehicles arrived onsite between previous and current check (not recorded in Platform as available at check time but currently available)</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehicleArrivalsFromKeyChecksSource">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleDeparturesFromKeyChecksSource.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehicleDeparturesFromKeyChecksSource.length}}</b> <span class="accordion-header-text">vehicles left site between previous and current check  (recorded in Platform as available at check time but currently not available)</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehicleDeparturesFromKeyChecksSource">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
            </div>

            <div *ngIf="checkTypeSelected == 'Vehicle Locked Check'">
                <div *ngIf="successfulLockedChecks.length > 0"> Check performed by <b>{{successfulLockedChecks[0].check_in_user}}</b>. Started at <b>{{formatTime(sortedSuccessfulLockedChecks[0].created_date)}}</b>. Finished at <b>{{formatTime(sortedSuccessfulLockedChecks[sortedSuccessfulLockedChecks.length - 1].created_date)}}</b></div>
                <details *ngIf="lockedReconciliations.length > 0">
                    <summary class="right-arrow">
                        <b>{{lockedReconciliations.length}}</b> <span class="accordion-header-text">vehicles reconciled</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="lockedReconciliations">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.Reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Outcome: {{ displayReconciliationOutcome(vehicle.vehicle_is_locked_check_reconciliation_outcome, undefined) }}
                                    </p>
                                    <p>
                                        Reconciled on: {{formatDateTime(vehicle.vehicle_is_locked_check_reconciliation_date)}}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.vehicle_is_locked_check_reconciliation_by }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
                <details *ngIf="successfulLockedChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{successfulLockedChecks.length}}</b> <span class="accordion-header-text">vehicles confirmed as locked</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="successfulLockedChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle.reg }}
                                </span>
                                <stack-item pFill>
                                    <p>
                                        {{ vehicle.check_type }} |
                                        Status: {{ vehicle.check_status }}
                                    </p>
                                    <p class="sub-text">
                                        By: {{ vehicle.check_in_user }} |
                                        Location: {{ vehicle.check_in_location }}
                                    </p>
                                </stack-item>

                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleCheckDtos.length > 0 && vehiclesMissedLockedChecks.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehiclesMissedLockedChecks.length}}</b> <span class="accordion-header-text">locked vehicles unaccounted for</span>
                    </summary>


                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehiclesMissedLockedChecks">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleArrivalsFromLockedChecksSource.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehicleArrivalsFromLockedChecksSource.length}}</b> <span class="accordion-header-text">vehicles arrived before vehicle locked check completed (not recorded in Platform as available at check time but currently available)</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehicleArrivalsFromLockedChecksSource">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>

                <details *ngIf="vehicleDeparturesFromLockedChecksSource.length > 0">
                    <summary class="right-arrow">
                        <b>{{vehicleDeparturesFromLockedChecksSource.length}}</b> <span class="accordion-header-text">vehicles left before vehicle locked check completed (recorded in Platform as available at check time but currently not available)</span>
                    </summary>
                    <item-list  [pLoading]="loading > 0" [pDataSource]="vehicleDeparturesFromLockedChecksSource">
                        <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle">
                            <stack pAlignment="center">
                                <span class="vehicle-plate">
                                    {{ vehicle }}
                                </span>
                                <a (click)="redirectToReconciliation(vehicle)" class="btn btn--primary">Reconcile</a>                                
                            </stack>
                        </item-list-item>

                    </item-list>                   
                </details>
            </div>
        </card-section>
    </card>
</page>